/**
 * Single source of truth for user-facing document uploads (must match backend
 * documents.constants.MAX_USER_DOCUMENT_UPLOAD_MB).
 */
export const MAX_DOCUMENT_UPLOAD_MB = 3;
export const MAX_DOCUMENT_UPLOAD_BYTES = MAX_DOCUMENT_UPLOAD_MB * 1024 * 1024;
